/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Icon, Stack } from "@fluentui/react";
import { observer } from "mobx-react";
import * as React from "react";

import ShiftThemeContainer from "../ShiftThemeContainer";

import { getIconStyle } from "./BaseShiftCard.mappers";
import { getClassNames } from "./BaseShiftCard.styles";
import { BaseShiftCardProps } from "./BaseShiftCardProps";

/**
 * Base shift component.
 * @param props Props for the component.
 */
export const BaseShiftCard: React.FC<BaseShiftCardProps> = observer(props => {
    const { theme, title, secondaryText, tertiaryText, icon, addMarginBottom, addMarginTop } = props;
    const styles = getClassNames({ addMarginBottom, addMarginTop });
    const iconStyle = getIconStyle(styles, icon);

    return (
        <ShiftThemeContainer theme={theme} nonClickable={true} className={styles.themeContainer}>
            <Stack className={styles.root}>
                <Stack horizontal className={styles.titleLayout} horizontalAlign={"space-between"}>
                    <span className={styles.title}>{title}</span>
                    {iconStyle ? <Icon className={iconStyle} iconName={icon} /> : null}
                </Stack>
                <span className={styles.notes}>{secondaryText}</span>
                <span>{tertiaryText}</span>
            </Stack>
        </ShiftThemeContainer>
    );
});
